module.exports = __webpack_public_path__ + "img/eq-hammerdin-weapon.ec9271d1.png";